import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "@/components/ui/dialog";
import { useState } from "react";

import PaidConsultationForm from "./Form/PaidConsultationForm";
import { useTranslate } from "@/components/base/providers/TranslateProv";

const PaidConsultationData = ({
  selectedTimeId,
  selectedDateId,
  data,
  children,
}: {
  selectedTimeId: any;
  selectedDateId: any;
  data: any;
  children: any;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { locale } = useTranslate();
  return (
    <>
      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogTrigger asChild>{children}</DialogTrigger>

        <DialogContent
          locale={locale}
          className="mx-auto w-[95vw] md:w-fit max-w-[95vw] h-auto p-6"
        >
          <DialogHeader>
            <DialogTitle className="text-center text-lg md:text-xl w-full">
              {locale === "ar"
                ? " معلومات ستفيدنا للرد عليك وتجهيز لك ما تحتاجه"
                : "Information to help us respond to you and provide what you need"}
            </DialogTitle>
          </DialogHeader>

          {/* form */}
          <PaidConsultationForm
            selectedTimeId={selectedTimeId}
            selectedDateId={selectedDateId}
            data={data}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PaidConsultationData;
